/* ---- quick-chat ----------------------------------------------------------
   Two pieces, both driven by packages/client/src/chat.js and both built from
   shared/phrases.js so the page can never say a word the table does not
   (the #happy bargain again).  #bubbles is the screen-space layer the
   speech bubbles live in -- placed by projecting the speaking cat every
   frame, so per-frame writes are transform and opacity only; the one
   layout this costs is a single measure when a phrase is set.  The bubble
   inverts the panel palette (ink ground, dark text) on purpose: speech
   belongs to the WORLD, and a bubble dressed like the HUD would read as
   one more meter.  #chat is the phrase menu, bottom-centre like #charge
   because the player's eyes are on their cat while they talk; rows are
   real buttons so touch is the same menu tapped. */
#bubbles{position:fixed;inset:0;z-index:3;pointer-events:none;overflow:hidden}
.bubble{position:absolute;left:0;top:0;width:max-content;max-width:230px;
  padding:7px 11px 8px;background:var(--ink);color:#171812;border-radius:10px;
  font-family:"Archivo",system-ui,sans-serif;font-weight:600;font-size:.8rem;
  line-height:1.3;text-align:center;
  opacity:0;transition:opacity .12s ease-out;will-change:transform}
.bubble::after{content:"";position:absolute;left:50%;bottom:-6px;margin-left:-6px;
  border:6px solid transparent;border-top-color:var(--ink);border-bottom:none}
.bubble.show{opacity:1}
/* After .show, so timing out beats being on screen. */
.bubble.fade{opacity:0;transition:opacity .4s ease-in}
#chat{left:50%;bottom:96px;transform:translateX(-50%);z-index:6;
  width:min(300px,calc(100vw - 24px));padding:12px 13px 13px;
  display:flex;flex-direction:column;gap:8px}
#chat .chat-head{display:flex;align-items:baseline;gap:8px}
#chat .chat-head .label:first-child{flex:1}
#chat .chat-note{color:var(--accent);text-transform:none;letter-spacing:.04em}
.chat-rows{display:flex;flex-direction:column;gap:3px}
.chat-rows[hidden]{display:none}
.chat-rows button{display:flex;align-items:center;gap:10px;text-align:left;
  font-family:inherit;font-size:.74rem;color:var(--ink);background:transparent;
  border:1px solid transparent;border-radius:3px;padding:5px 7px;cursor:pointer;
  transition:border-color .12s,background .12s}
.chat-rows button:hover{border-color:var(--edge);background:rgba(241,239,232,.06)}
.chat-rows button:focus-visible{outline:2px solid var(--accent);outline-offset:2px}
/* The #keys keycap treatment: on this panel the digits ARE the interface. */
.chat-rows button b{color:#171812;background:var(--accent);border-radius:3px;
  font-weight:500;font-size:.64rem;min-width:22px;text-align:center;padding:2px 0}
.chat-rows button span{flex:1}
/* The thumb path: the say pad (sized with its #pads siblings -- the rule
   lives here to keep this feature's CSS in one block), a menu lifted clear
   of the bliss toast's bottom band, and rows grown to the 44 px floor the
   other touch targets respect. */
[data-touch="say"]{width:50px;height:50px;font-size:.54rem}
html.touch #chat{bottom:calc(100px + env(safe-area-inset-bottom))}
html.touch .chat-rows button{padding:10px 9px;font-size:.8rem}
